import { Component, OnDestroy, signal, TemplateRef, ViewChild } from '@angular/core';
import { CompanyService } from '../../configuration/company/company.service.service';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { getCode } from 'app/utils/method';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { AssetAttributes, ShortCompanyAttributes, SubRouteAttributes, VisitUserAttributes } from '@albatrosdeveloper/ave-models-package';
import { IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { CommonModule } from '@angular/common';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import DistributionChainAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity';
import { DistributionChainService } from '../../configuration/distribution-chain/distribution-chain.service';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { SalesOfficeService } from '../../configuration/sales-office/sales-office.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { DeleteConfirmationComponent } from '../../business-partners/business-partner/delete-modal/delete-modal.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ICreateAssetControl } from './interfaces/asset-control.interface';
import RouteAttributes from '@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity';
import { RouteService } from '../../routing/route/route.service';
import { SubRouteService } from '../../routing/sub-routes/sub-route.service';
import { AssetService } from '../asset.service';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { ShipToInterface } from '../../sales/order-generate/interfaces/fetch-ship-to.interface';
import { environment } from 'environments/environment.prod';
import { OrdersCreationService } from '../../sales/order-generate/order-generate.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ColorPickerModule } from 'ngx-color-picker';
import { AssetControlService } from './asset-control.service';
import AssetControlAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/assets/asset-control/asset-control.entity';
import { BusinessPartnerService } from '../../business-partners/business-partner/business-partner.service';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { OrdersListService } from '../../sales/order-list-components/order-list.service';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { DatesFiltersComponent } from '../../filters/dates-filters/dates-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { DateHelper } from 'app/utils/date.helper';




@Component({
  selector: 'app-asset-control',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    ColorPickerModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    DatesFiltersComponent,
    HoverMenuDirective
  ],
  templateUrl: './asset-control.component.html',
  styleUrl: './asset-control.component.scss'
})
export class AssetControlComponent implements OnDestroy {
  getCode = getCode
  displayedColumns: string[] = [
    "asset",
    "distributionChain",
    "salesOffice",
    //"routes",
    "subRoute",
    "shipTo",
    "assignmentStartDate",
    "assignmentEndDate",
    //"user",
    "document",
    "statusId",
    "action"
  ];

  dataSource = new MatTableDataSource<any>([]);
  
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof AssetControlAttributes = "asset";
  sortDirection: "ASC" | "DESC" = "ASC";

  listDistributionChain: DistributionChainAttributes[];
  salesOfficeList: SalesOfficeAttributes[] = [];
  listFilterSalesOfficeList = signal<SalesOfficeAttributes[]>([]);
  searchOffice = ''

  routeList: RouteAttributes[] = [];
  listFilterRouteList = signal<RouteAttributes[]>([]);
  searchRoute = ''

  subRouteList: SubRouteAttributes[] = [];
  listFilterSubRouteList = signal<SubRouteAttributes[]>([]);
  searchSubRoute = ''

  listUser: VisitUserAttributes[];

  listAsset: AssetAttributes[] = [];

  shipToControl = new FormControl('', Validators.required);
  shipToList: any[] = [];
  shipToFilterList: any[] = [];
  shipToSelected: any = null;

  listButtonType = [
    {code: '0', name: 'Asignado'},
    {code: '1', name: 'Servicio Técnico'},
    {code: '2', name: 'Averia'},
    {code: '3', name: 'Préstamo en Envase'},
  ]

  currentAssetControl: ICreateAssetControl = this.initializeCreateControl();
  public id: any = null

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;

  assetCompany: ShortCompanyAttributes = null;

  //BUSCADOR
  searchSubscription: Subscription;

  selectedStatuses: number[]=[];
  form: FormGroup;

  // Lazy loading flags
  loadFiltersData = false;
  private modalDataLoaded = false;

  constructor(
    //private memberNotificationService: MemberNotificationService,
    private readonly companyService: CompanyService,
    private readonly distributionChainService: DistributionChainService,  
    private readonly salesOfficeService: SalesOfficeService,  
    private readonly routeService: RouteService,
    private readonly subRouteService: SubRouteService,
    private readonly assetService: AssetService,
    private readonly assetControlService: AssetControlService,
    private readonly bussinessPartnerService: BusinessPartnerService,
    private readonly ordersListService: OrdersListService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
  ) {
    const today = new Date();
    this.form = this.fb.group({
      start: [today],
      end: [today],
      companyId: [],
      distributionChainId:[],
      salesOfficeId:[]
    });
   }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.getList();
    // Distribution chain and assets will be loaded lazily when modal opens

    this.shipToControl.valueChanges.pipe(
        debounceTime(500),
        distinctUntilChanged()
      ).subscribe(value => {

        if (typeof value === 'string' && value.trim().length === 24 && /^[a-f0-9]{24}$/.test(value)) {
          return;
        }
        this.shipToList = []//al buscar se debe reiniciar
        this.fetchShipTo(value)
      })
  }

  onSelectionChange(){
    let auxAsset = this.listAsset.find(a => a._id.toString() == this.currentAssetControl.asset)
    this.assetCompany = auxAsset && auxAsset.companies && auxAsset.companies.length>0 ? auxAsset.companies[0] : null;
    this.getAllSalesOfficeList(this.assetCompany._id.toString())
    this.getAllRouteList(this.assetCompany._id.toString());
  }

  applyFilter(filterNotificactionMember: string) {
    this.pageIndex = 1
    this.search = filterNotificactionMember
    this.getList()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  private getSortField(): keyof AssetControlAttributes {
    const sortFieldMapping: Record<string, keyof AssetControlAttributes> = {
      /*
      status: "statusERP",
      type: "type",
      trip: <any>"trip.id",
      subRoute: <any>"subRoute.name",
      user: <any>"user.user_login.username",
      soldTo: <any>"soldTo.name",
      documentNumber: "serial",
      class: <any>"class.name",
      date: "deliveryDateTime",
      creation: "creationDateTime",
      */
      distributionChain: <any>"distributionChain.name",
      salesOffice: <any>"salesOffice.name",
      routes: <any>"routes.name",
      subRoute: <any>"subRoute.name",
      soldTo: <any>"soldTo.name",
      shipTo: <any>"shipTo.name",
      asset: <any>"asset.name"
    }
    return sortFieldMapping[this.sortActive] || <any>"asset.name";
  }
   
  clearFilters() {
    this.form.reset({
      start: new Date(),
      end: new Date(),
      companyId: null,
      salesOffficeId: null,
      distributionChainId: null
    })
    this.getList()
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  

  getList(): void {
    const sortField = this.getSortField();
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: sortField, sortDirection: this.sortDirection }

    let filter: IFilters = {
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate: DateHelper.getEndOfDay(this.form.get("end")?.value) ?? DateHelper.getEndOfDay(this.form.get("start")?.value) ?? null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      distributionChainId: this.form.get("distributionChainId")?.value,
      status: this.selectedStatuses.length ? this.selectedStatuses : null
    }
        
    this.assetControlService.getAllPaginate(options,filter).subscribe({
      next: (res: IPaginationResult<any>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener grupos","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreateControl(): ICreateAssetControl {
    this.shipToControl.setValue(null);

    return { 
        distributionChain: null,
        salesOffice: null,
        routes: [],
        subRoute: null,
        assignmentStartDate: null,
        assignmentEndDate: null,
        user: null,
        soldTo: null,
        shipTo: null,
        asset: null,
        document: null,
        comment: null,
        status: null,
        type: null,
        buttonType: null,
        buttonColor: null,
        buttonTextColor: null,
    };
  }

  //start filter
  private fetchAllDistributionChain() {
    this.distributionChainService.findToComboBox().subscribe({
      next: (res) => {
        this.listDistributionChain = res.data;
      },
    });
  }

  getAllSalesOfficeList(companyId: string): void {
    this.salesOfficeService.findToComboBox(companyId).subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
        this.listFilterSalesOfficeList.update(()=> this.salesOfficeList.slice());
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error fetching sales office","Cerrar",{ duration: 5000});
      },
    });
  }
  
  changueOptionsSalesOffice(event){
    if (!this.salesOfficeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSalesOfficeList.update(() => this.salesOfficeList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSalesOfficeList.update(() => this.salesOfficeList.filter(item => item.externalKeys?.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1))
  }

  changueOptionsSubRoute(event){
    if (!this.subRouteList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSubRouteList.update(() => this.subRouteList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSubRouteList.update(() => this.subRouteList.filter(item => item.externalKeys?.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1))
  }

  changueOptionsRoute(event){
    if (!this.routeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterRouteList.update(() => this.routeList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterRouteList.update(() => this.routeList.filter(item => item.externalKeys?.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1))
  }

  getAllRouteList(companyId: string): void {
    this.routeService.findToComboBox(companyId).subscribe({
      next: (res) => {
        this.routeList = res.data;
        this.listFilterRouteList.update(()=> this.routeList.slice());
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener territorios.","Cerrar",{ duration: 5000});
      },
    });
  }

  getAllSubRouteList(saleOfficeId: string): void {
    this.subRouteService.findToComboBox(saleOfficeId).subscribe({
      next: (res) => {
        this.subRouteList = res.data;
        this.listFilterSubRouteList.update(()=> this.subRouteList.slice());
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener rutas.","Cerrar",{ duration: 5000});
      },
    });
  }

  getAllAssetList(): void{
    this.assetService.findToComboBox().subscribe({
      next: (res) => {
        this.listAsset = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener activos.","Cerrar",{ duration: 5000});
      },
    });
  }

  fetchShipTo(search?): void {
    let dataToSend: any = {
      companyIds: [environment.companyId],
      search: search?.toString() || '',
    }

    if(this.currentAssetControl.subRoute && this.currentAssetControl.subRoute != ''){
      dataToSend['subRouteMongoId'] = this.currentAssetControl.subRoute;
    }

    this.ordersListService.fetchShipTos(dataToSend).subscribe((res) =>{
      this.shipToList = res?.data;
      this.shipToFilterList = [...this.shipToList];

      if(this.shipToList.length == 1){
        this.shipToControl.setValue(this.shipToList[0]._id.toString())
      }
      this.onShipToChange();
    })
  }

  onShipToChange(): void{
    this.shipToSelected = this.shipToList.find(st => st._id.toString() == this.shipToControl.value);

    if(this.shipToSelected){
      this.currentAssetControl.soldTo = this.shipToSelected.soldToMongoId;
      this.currentAssetControl.shipTo = this.shipToSelected._id;
    }
    
  }

  fetchShipToName = (shiptoId: string): string => {
    const foundShipTo = this.shipToList.find(shipTo => shipTo._id.toString() === shiptoId);
    if (foundShipTo) {
      return foundShipTo.name;
    }
    return '';
  }

  //end Filter

  private ensureModalDataLoaded(): void {
    if (!this.modalDataLoaded) {
      this.fetchAllDistributionChain();
      this.getAllAssetList();
      this.modalDataLoaded = true;
    }
  }

  openModal(controlA?: any): void {
    this.ensureModalDataLoaded();

    if(controlA){
      this.currentAssetControl = {
        ...controlA,
        asset: controlA.asset ? controlA.asset._id.toString() : "",
        distributionChain: controlA.distributionChain ? controlA.distributionChain._id.toString() : null,
        salesOffice: controlA.salesOffice ? controlA.salesOffice._id.toString() : null,
        routes: controlA.routes && controlA.routes.length > 0 ? controlA.routes.map((r) => r._id.toString()) : [],
        subRoute: controlA.subRoute ? controlA.subRoute._id.toString() : "",
        type: controlA.type == '1' ? true : false,
      };
      this.id = controlA._id
      
      this.setUpButton(controlA.status);

      let auxCompany = controlA.asset && controlA.asset.companies && controlA.asset.companies.length > 0 ? controlA.asset.companies[0] : null
      this.getAllSalesOfficeList(auxCompany ? auxCompany._id.toString() : '');
      this.getAllRouteList(auxCompany ? auxCompany._id.toString() : '');
      this.getAllSubRouteList(this.currentAssetControl.salesOffice);

      this.shipToControl.setValue(controlA.shipTo._id.toString());

      this.fetchShipTo(controlA.shipTo.name);

    }else{
      this.currentAssetControl = this.initializeCreateControl();
      this.id = null;
      this.fetchShipTo('');
    }

    this.dialogRef = this.dialog.open(this.actionModal, { width: '90%', disableClose: true })
    this.dialogRef.afterClosed().subscribe((result) => { result });
  }

  onSubmit(){
    if(this.id == null){
      this.createAssetControl()
    }else{
      this.updateAssetControl(this.id)
    }
  }

  createAssetControl(): void {
    
    const dataToSend: any = {
      assignmentStartDate: this.currentAssetControl.assignmentStartDate,
      assignmentEndDate: this.currentAssetControl.assignmentEndDate,
      document: this.currentAssetControl.document,
      comment: this.currentAssetControl.comment,
      status: `${this.currentAssetControl.buttonType}-${this.listButtonType.find(t => t.code ==this.currentAssetControl.buttonType)?.name}-${this.colorStringToArgbHex(this.currentAssetControl.buttonColor)}-${this.colorStringToArgbHex(this.currentAssetControl.buttonTextColor)}`,
      type: this.currentAssetControl.type ? '1' : '0',
      subRouteId: this.currentAssetControl.subRoute,
      assetId: this.currentAssetControl.asset,
      salesOfficeId: this.currentAssetControl.salesOffice,
      //masterUserId: null,
      shipToId: this.currentAssetControl.shipTo,
      soldToId: this.currentAssetControl.soldTo,
      distributionChainId: this.currentAssetControl.distributionChain,
      routeIds: this.currentAssetControl.routes
    }
    
    this.assetControlService.create(dataToSend).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        if(this.dialogRef){
          this.dialogRef.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateAssetControl(id: string): void {
   if (this.currentAssetControl) {
      const dataToUpdate: any = {
        assignmentStartDate: this.currentAssetControl.assignmentStartDate,
        assignmentEndDate: this.currentAssetControl.assignmentEndDate,
        document: this.currentAssetControl.document,
        comment: this.currentAssetControl.comment,
        status: `${this.currentAssetControl.buttonType}-${this.listButtonType.find(t => t.code ==this.currentAssetControl.buttonType)?.name}-${this.colorStringToArgbHex(this.currentAssetControl.buttonColor)}-${this.colorStringToArgbHex(this.currentAssetControl.buttonTextColor)}`,
        type: this.currentAssetControl.type ? '1' : '0',
        subRouteId: this.currentAssetControl.subRoute,
        assetId: this.currentAssetControl.asset,
        salesOfficeId: this.currentAssetControl.salesOffice,
        //masterUserId: null,
        shipToId: this.currentAssetControl.shipTo,
        soldToId: this.currentAssetControl.soldTo,
        distributionChainId: this.currentAssetControl.distributionChain,
        routeIds: this.currentAssetControl.routes
      }

      this.assetControlService.update(id, dataToUpdate).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          if(this.dialogRef){
            this.dialogRef.close(true);
          }
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, memberN: any): void {
    const originalStatusId = memberN.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedMemberN = { 
      ...memberN, 
      statusId: updatedStatusId 
    };

    /*this.memberNotificationService.update(memberN._id.toString(), updatedMemberN).subscribe({
      next: () => {
        this.getList();
      },
      error: () => {
        memberN.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });*/
  }

  onTypeChange(event: boolean, controlA: any): void {
    const originalTypeId = controlA.type;
    const updatedStatusId = event ? '1' : '0';

    /*

    */
  }

  openDeleteDialog(memberN: any): void {
    this.dialog
      .open(this.deleteDialog, { data: memberN, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(memberN._id.toString()));
  }

  delete(id: string): void {
    this.assetControlService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  colorStringToArgbHex(color: string): string | null {
    color = color.trim().toLowerCase();

    // Caso: rgba(r,g,b,a)
    const rgbaMatch = color.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/);
    if (rgbaMatch) {
      const [, rStr, gStr, bStr, aStr] = rgbaMatch;
      const r = parseInt(rStr, 10);
      const g = parseInt(gStr, 10);
      const b = parseInt(bStr, 10);
      const a = parseFloat(aStr);
      const alpha = Math.round(a * 255);
      return this.toArgbHex(alpha, r, g, b);
    }

    // Caso: #rrggbb
    const hexMatch = color.match(/^#([0-9a-f]{6})$/i);
    if (hexMatch) {
      const hex = hexMatch[1];
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return this.toArgbHex(255, r, g, b);
    }

    return null;
  }

  toArgbHex(a: number, r: number, g: number, b: number): string {
    const aHex = a.toString(16).padStart(2, '0').toUpperCase();
    const rHex = r.toString(16).padStart(2, '0').toUpperCase();
    const gHex = g.toString(16).padStart(2, '0').toUpperCase();
    const bHex = b.toString(16).padStart(2, '0').toUpperCase();
    return `0x${aHex}${rHex}${gHex}${bHex}`;
  }

  formatDate(date: string | Date, includeTime?: boolean): string {
    if(date){
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, '0');
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const year = d.getFullYear();

      if (includeTime) {
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        const seconds = d.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }  
      return `${day}-${month}-${year}`;
    }
    return '--:--:--'
  }

  setUpButton(config: string): void {
    const parts = config.split('-');

    if (parts.length < 4) {
      this.snackBar.open("Formato inválido","Cerrar",{ duration: 5000});
      return;
    }

    const buttonType = parts[0];
    const buttonColorHex = parts[2];
    const buttonTextColorHex = parts[3];

    this.currentAssetControl.buttonType = buttonType;
    this.currentAssetControl.buttonColor = this.argbToRgbaCss(buttonColorHex);
    this.currentAssetControl.buttonTextColor = this.argbToRgbaCss(buttonTextColorHex);
  }

  // Convierte 0xAARRGGBB a rgba(r, g, b, a)
  argbToRgbaCss(argb: string): string {
    const hex = argb.replace(/^0x/i, '').padStart(8, '0');

    const a = parseInt(hex.substring(0, 2), 16) / 255;
    const r = parseInt(hex.substring(2, 4), 16);
    const g = parseInt(hex.substring(4, 6), 16);
    const b = parseInt(hex.substring(6, 8), 16);

    return `rgba(${r}, ${g}, ${b}, ${a.toFixed(2)})`;
  }
   
  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
